import {
    DXP_ADD_FEATURED_CONTENT,
    DXP_ADD_FEATURED_CONTENT_ERROR,
    DXP_DELETE_CONTENT,
    DXP_DELETE_CONTENT_ERROR,
    DXP_GET_FEATURED_HOME_TOP,
    DXP_GET_FEATURED_HOME_COURSES,
    DXP_GET_FEATURED_HOME_XPERTS,
    DXP_GET_FEATURED_HOME_CARD,
    DXP_GET_FEATURED_HOME_RECOMMENDED,
    DXP_GET_FEATURED_HOME_CONTENT_ERROR,
    DXP_GET_FEATURED_HOME_TRENDING_1,
    DXP_GET_FEATURED_HOME_TRENDING_2,
    DXP_GET_FEATURED_HOME_TRENDING_3,
} from "../actions/types";

const initialState = {
    count: null,
    featuredTop: [],
    featuredPremiumCourses: [],
    featuredXperts: [],
    featuredHomeCard: [],
    featuredTrending1: [],
    featuredTrending2: [],
    featuredTrending3: [],
    featuredRecommended: [],
    isLoading: true,
    success: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case DXP_GET_FEATURED_HOME_TOP:
            return {
                ...state,
                featuredTop: payload,
                isLoading: false,
                success: true,
            };
        case DXP_GET_FEATURED_HOME_COURSES:
            return {
                ...state,
                featuredPremiumCourses: payload,
                isLoading: false,
                success: true,
            };
        case DXP_GET_FEATURED_HOME_XPERTS:
            return {
                ...state,
                featuredXperts: payload,
                isLoading: false,
                success: true,
            };
        case DXP_GET_FEATURED_HOME_CARD:
            return {
                ...state,
                featuredHomeCard: payload,
                isLoading: false,
                success: true,
            };

        case DXP_GET_FEATURED_HOME_TRENDING_1:
            return {
                ...state,
                featuredTrending1: payload,
                isLoading: false,
                success: true,
            };
        case DXP_GET_FEATURED_HOME_TRENDING_2:
            return {
                ...state,
                featuredTrending2: payload,
                isLoading: false,
                success: true,
            };
        case DXP_GET_FEATURED_HOME_TRENDING_3:
            return {
                ...state,
                featuredTrending3: payload,
                isLoading: false,
                success: true,
            };
        case DXP_GET_FEATURED_HOME_RECOMMENDED:
            return {
                ...state,
                featuredRecommended: payload,
                isLoading: false,
                success: true,
            };
        case DXP_ADD_FEATURED_CONTENT:
        case DXP_DELETE_CONTENT:
            return {
                ...state,
                isLoading: false,
                success: true,
            };
        case DXP_ADD_FEATURED_CONTENT_ERROR:
        case DXP_DELETE_CONTENT_ERROR:
        case DXP_GET_FEATURED_HOME_CONTENT_ERROR:
            return {
                ...state,
                isLoading: false,
                success: true
            }
        default:
            return state;
    }
}
